import { Flex, Tag, Typography } from '@duxton-web/ui';
import { cpGetCountries } from 'omega-rtc/actions/ucd';
import React from 'react';

import { countryFromApi, langLabel, localeSorter } from './adapters';
import EntityListPage, { useEntityList } from './EntityListPage';

const columns = [
  {
    title: 'Country',
    dataIndex: 'name',
    width: '20%',
    sorter: localeSorter('name', 'id'),
    render: (_v, c) => (
      <Typography.Body level={2}>{c.name || c.id}</Typography.Body>
    ),
  },
  {
    title: 'Code',
    dataIndex: 'id',
    width: 100,
    render: (id) => <Tag>{id}</Tag>,
  },
  {
    title: 'Languages',
    dataIndex: 'langs',
    render: (langs) => (
      <Flex gap={4} wrap="wrap">
        {(langs || []).map((code) => <Tag key={code} color="volcano">{langLabel(code)}</Tag>)}
      </Flex>
    ),
  },
  {
    title: 'Currencies',
    dataIndex: 'currencies',
    width: 220,
    render: (currencies) => (
      <Flex gap={4} wrap="wrap">
        {(currencies || []).map((code) => <Tag key={code} color="blue">{code}</Tag>)}
      </Flex>
    ),
  },
];

const CountriesPage = () => {
  const { data, loading } = useEntityList(
    cpGetCountries, 'ucd.cpCountries', 'requests.cpGetCountriesRequest', countryFromApi,
  );
  const sortedData = React.useMemo(() => [...data].sort(localeSorter('id')), [data]);
  return (
    <EntityListPage
      title="Countries"
      rowKey="id"
      columns={columns}
      data={sortedData}
      loading={loading}
      emptyText="No countries configured yet."
    />
  );
};

export default CountriesPage;
